export const SellAndRentGrantorTypeEnum = {
  INDIVIDUAL: "INDIVIDUAL",
  CORPORATE: "CORPORATE",
};

export const SellAndRentGrantorType = {
  INDIVIDUAL: "บุคคลธรรมดา",
  CORPORATE: "นิติบุคคล",
};

const POA_DOCUMENT = {
  field: "poa_document_url",
  label: "เอกสารมอบอำนาจ",
};

const GRANTEE_ID_CARD = {
  field: "grantee_id_card_url",
  label: "สำเนาบัตรประชาชนผู้รับมอบอำนาจ",
};

// The documents an admin has to check depend on who grants the power of
// attorney, and each type has its own fixed review order. The company seal
// document is only required when the company has a seal, so an empty slot there
// is not necessarily a gap.
export const SellAndRentPowerOfAttorneyDocuments = {
  [SellAndRentGrantorTypeEnum.INDIVIDUAL]: [
    POA_DOCUMENT,
    {
      field: "grantor_id_card_url",
      label: "สำเนาบัตรประชาชนผู้มอบอำนาจ",
    },
    GRANTEE_ID_CARD,
  ],
  [SellAndRentGrantorTypeEnum.CORPORATE]: [
    POA_DOCUMENT,
    {
      field: "company_registration_document_url",
      label: "สำเนาหนังสือรับรองบริษัท อายุไม่เกิน 3 เดือน",
    },
    {
      field: "grantor_id_card_url",
      label: "สำเนาบัตรประชาชนกรรมการผู้มีอำนาจลงนาม",
    },
    {
      field: "company_seal_document_url",
      label: "สำเนาเอกสารแสดงตราประทับบริษัท เช่น บอจ.3 (กรณีบริษัทมีตราประทับ)",
    },
    GRANTEE_ID_CARD,
  ],
};
